// ComparisonGrid.jsx — Task 11 artifact slot. Two-column head-to-head metric table.
// Props: { columns:[colA, colB], rows:[{ label, a, b, winner? }] } — winner ∈ 'a' | 'b'.
import React from "react"

export default function ComparisonGrid({ columns, rows }) {
  if (!Array.isArray(rows) || rows.length === 0) return null
  const cols = Array.isArray(columns) ? columns : ["A", "B"]
  return (
    <div className="afq-card" data-slot="comparison_grid">
      <div className="afq-cmp">
        <div className="afq-cmp-row afq-cmp-head">
          <span className="afq-cmp-l" />
          {cols.map((c, i) => (
            <span className="afq-cmp-c" key={i}>{c}</span>
          ))}
        </div>
        {rows.map((r, i) => {
          // Canonical row is { label, a, b, winner }; also tolerate the design-mock { label, values:[] }.
          const cells = Array.isArray(r.values) ? r.values : [r.a, r.b]
          return (
            <div className="afq-cmp-row" key={i}>
              <span className="afq-cmp-l">{r.label}</span>
              {cells.map((v, j) => (
                <span
                  key={j}
                  className={"afq-cmp-c" + ((r.winner === "a" && j === 0) || (r.winner === "b" && j === 1) ? " win" : "")}
                >
                  {v == null ? "" : String(v)}
                </span>
              ))}
            </div>
          )
        })}
      </div>
    </div>
  )
}
